import type { CSSProperties, ReactNode } from "react";
import { Link } from "@tanstack/react-router";

/** Slugs that have their own canonical vanity route. */
const VANITY: Record<string, "/train-factory"> = {
  "train-factory": "/train-factory",
  konepaja: "/train-factory",
};

type Props = {
  slug: string;
  className?: string;
  style?: CSSProperties;
  children: ReactNode;
};

/** Links to a district hub, preferring its canonical vanity URL when it has one. */
export function DistrictLink({ slug, className, style, children }: Props) {
  const vanity = VANITY[slug];
  if (vanity) {
    return (
      <Link to={vanity} className={className} style={style}>
        {children}
      </Link>
    );
  }
  return (
    <Link to="/districts/$slug" params={{ slug }} className={className} style={style}>
      {children}
    </Link>
  );
}
